<template>
    <v-hover v-slot="{ hover }" open-delay="200" >
        <div class="app-side-buttons">
            <v-scale-transition>
                <div v-show="hover || permanent || showMenu">
                    <inc-create-button
                        v-if       = "site"
                        :site      = "site"
                        @opend     = "onCreateOpen"
                        class      = "mb-3"
                    />

                    <c-menu-button
                        label      = "inc.overview.menu.export"
                        icon       = "mdi-download"
                        icon-color = "primary--text"
                        @click     = "onDownload"
                    />

                    <c-menu-button
                        label      = "inc.overview.menu.refresh"
                        icon       = "mdi-refresh"
                        icon-color = "primary--text"
                        @click     = "onRefresh"
                    />

                    <c-menu-button
                        v-if       = "incidentFlter && !incidentFlter.ignoreDeleted"
                        label      = "inc.overview.menu.filteroff"
                        icon       = "mdi-filter-outline"
                        icon-color = "primary--text"
                        @click     = "onFilterDeleted"
                    />

                    <c-menu-button
                        v-if       = "incidentFlter && incidentFlter.ignoreDeleted"
                        label      = "inc.overview.menu.filteron"
                        icon       = "mdi-filter"
                        icon-color = "red--text"
                        @click     = "onFilterDeleted"
                    />
                </div>
           </v-scale-transition>
        </div>
    </v-hover>
</template>

<script>

import CMenuButton from "@/modules/core/components/utils/CMenuButton.vue";
import IncCreateButton from "@/modules/inc/steps/components/common/menu/private/IncCreateButton.vue";

export default {
    name: "CIncOverviewMenu",

    components: {
        IncCreateButton,
        CMenuButton
    },

    props: {
        site: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        }
    },

    data: () => ({
        showMenu: false,
    }),

    computed: {
        permanent () {
            return this.preferences["permanentMenu"];
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        incidentFlter () {
            return this.$store.getters.preferences["userFilter"];
        },
    },

    methods: {
        onCreateOpen (open) {
            this.showMenu = open;
        },

        onFilterDeleted () {
            this.incidentFlter.ignoreDeleted = !this.incidentFlter.ignoreDeleted;
            this.$store.dispatch("setIncidentFilter", this.incidentFlter).then (() => {
                this.$emit("filter");
            })
        },

        onDownload () {
            this.$emit("download");
        },

        onRefresh () {
            this.$emit("refresh");
        },
    }
}
</script>
